import { useState } from "react";
import { Star, Trash2, GripVertical } from "lucide-react";

export function SortableGallery({ urls, onChange, testPrefix, coverIndex = 0, coverLabel = "Copertina" }) {
  const [drag, setDrag] = useState(null);
  const [over, setOver] = useState(null);

  const reorder = (from, to) => {
    if (from === null || to === null || from === to) return;
    const arr = [...urls];
    const [it] = arr.splice(from, 1);
    arr.splice(to, 0, it);
    onChange(arr);
  };
  const setCover = (i) => { if (i !== coverIndex) reorder(i, 0); };
  const remove = (i) => onChange(urls.filter((_, j) => j !== i));

  return (
    <div className="grid grid-cols-3 sm:grid-cols-5 gap-2" data-testid={`${testPrefix}-gallery`}>
      {urls.map((u, i) => (
        <div
          key={u + i}
          draggable
          data-testid={`${testPrefix}-item-${i}`}
          onDragStart={() => setDrag(i)}
          onDragOver={(e) => { e.preventDefault(); setOver(i); }}
          onDragLeave={() => setOver(null)}
          onDrop={() => { reorder(drag, i); setDrag(null); setOver(null); }}
          onDragEnd={() => { setDrag(null); setOver(null); }}
          className={`relative group aspect-square rounded-lg overflow-hidden bg-stone-100 border-2 cursor-grab active:cursor-grabbing transition-all ${
            over === i && drag !== i ? "border-[#D06D4D] scale-95" : i === coverIndex ? "border-[#D06D4D]/60" : "border-stone-200"
          } ${drag === i ? "opacity-40" : ""}`}
        >
          <img src={u} alt="" draggable={false} className="w-full h-full object-cover pointer-events-none" />
          <span className="absolute top-1 right-1 text-white/90 drop-shadow"><GripVertical size={14} /></span>
          {i === coverIndex ? (
            <span data-testid={`${testPrefix}-cover-badge`} className="absolute top-1 left-1 bg-[#D06D4D] text-white text-[9px] uppercase tracking-widest px-1.5 py-0.5 rounded-full inline-flex items-center gap-1 shadow">
              <Star size={9} fill="currentColor" /> {coverLabel}
            </span>
          ) : (
            <button
              type="button"
              data-testid={`${testPrefix}-cover-${i}`}
              onClick={() => setCover(i)}
              title="Usa come copertina"
              className="absolute top-1 left-1 bg-white/90 hover:bg-[#D06D4D] hover:text-white text-stone-700 rounded-full w-7 h-7 flex items-center justify-center shadow"
            ><Star size={13} /></button>
          )}
          <button
            type="button"
            data-testid={`${testPrefix}-delete-${i}`}
            onClick={() => remove(i)}
            title="Elimina"
            className="absolute bottom-1 right-1 bg-red-600 text-white rounded-full w-7 h-7 flex items-center justify-center shadow"
          ><Trash2 size={12} /></button>
        </div>
      ))}
    </div>
  );
}
